var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.$parent.loading)?_c('div',{attrs:{"id":"site-loader"}},[_c('img',{attrs:{"src":"/img/SymfoniaHumanSystemHsys.png","width":"200","alt":"Hsys"}})]):_vm._e()]),_c('Navigation'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }